import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { TaxExtensionProgressionActionsContainer } from '@/features/jobs/details/components/JobProgressionCard/TaxExtensionProgressionActions/TaxExtensionProgressionActionsContainer'
import { AuthorizationRequestedProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/AuthorizationRequestedProgressionActions'

export interface AuthorizationRequestedProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const AuthorizationRequestedProgressionActionsContainer = observer(
  function AuthorizationRequestedProgressionActionsContainer({
    vm,
  }: AuthorizationRequestedProgressionActionsContainerProps) {
    return (
      <AuthorizationRequestedProgressionActions
        isAnyExtensionFlowAvailable={vm.isAnyExtensionFlowAvailable}
        onAuthorizationReceived={vm.answerAuthorizationSigned}
        extensionActions={
          vm.isAnyExtensionFlowAvailable && (
            <TaxExtensionProgressionActionsContainer vm={vm} isSecondary />
          )
        }
      />
    )
  },
)
